import { TipsMapType } from '../index';

export const netSentimentSelectTips: TipsMapType = {
  en: 'Net sentiment is the sentiment score after excluding invalid and low validation reviews.',
  zh: '剔除无效和低有效性评论后的情感分。',
};

export const sentimentSelectTips: TipsMapType = {
  en: 'Sentiment score is used to score the sentiment tendency of each comment through NLP algorithm and sentiment analysis, on a scale of 1-5.',
  zh: '情感分是通过NLP算法和情感分析来对每条评论的情感倾向进行打分，分值范围为1-5。',
};

export const gameListNetSentimentTips: TipsMapType = {
  en: 'Net Sentiment: Net Sentiment score, through NLP algorithm and sentiment analysis of reviews that excluded the low validation and invalid ones, is used to score the sentiment tendency on a scale of 1-5. Sentiment score greater than 3.5 is positive, score lower than 2.5 is negative, and score between 2.5-3.5 is neutral.',
  zh: '修正情感分：修正情感分将通过自然语言处理算法和情感分析，对剔除无效和低有效性评论后的评论情感倾向进行打分，分数范围为1-5。情感分大于3.5为正面，小于2.5为负面，在2.5到3.5之间为中性。',
};



export const gameListMentionsTips: TipsMapType = {
  en: 'Mentions: Summary of the number of Reviews (Posts & Comments). This includes all reviews of the game in the Game Store, as well as reviews captured on Social Media through monitor keywords and official accounts. Chatting data is not included in the Mentions for the game list.',
  zh: '声量：全网抓取到的玩家帖子和评论数汇总。包括游戏在游戏商店下的所有评论，以及通过监控词和官号在社交媒体上抓取到的评论。游戏列表的声量统计不包括Chatting数据。',
};

export const gameListKeywordTips: TipsMapType = {
  en: `Emerging Keywords: Keywords that appear in the last hour, but haven't appeared in the last 3 or 5 days (Days of Game Store/ Monitoring Keywords/ Monitor Accounts are different), as Emerging Keywords.`,
  zh: `突发关键词: 统计过去 1 个小时出现，但是过去 3 天或者 5 天没出现过的关键词（商店、监控关键词、监控官号来源的周期天数不同），作为游戏突发的关键词。
  `,
};
